
import MescrollVue from 'mescroll.js/mescroll.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Picker from 'vux/src/components/picker/index.vue'

import {querydevicelog} from '../../api/device'

export default {
name: 'historyList',
components: {
Picker,
MescrollVue 
},
directives: {
TransferDom
},
data () {
return {
years1: [],
year4: [],
changeTime: [],
pickerShow: false,
yearMonth: '',
start: '',
end: '',
alarmData: [],
deviceData: '',
cnt: 10,
page: 1,
mescrollUp: { // 上拉加载的配置.
callback: this.upCallback,
isBoth: true,
dataList: [] 
},
iconType: [
{type: 'dooropen', url: '../../../static/NB/second_history_opendoor.png'},
{type: 'doorclose', url: '../../../static/NB/second_history_closedoor.png'},
{type: 'sos', url: '../../../static/NB/second_history_SOS.png'},
{type: 'c-at', url: '../../../static/NB/second_history_dismantle.png'},
{type: 'sys_isactivity', url: '../../../static/NB/second_history_other.png'}
]
}
},
created () {
this.deviceData = this.$store.getters.get_child_obj
let years = []
let year1 = new Date().getFullYear()
let arr = this.deviceData.createon.split('-')
let createon = arr[0]
for (let i = parseInt(createon); i <= year1; i++) {
years.push({
name: i + '年',
value: i + ''
})
}
console.log(this.deviceData, createon)
this.years1 = [years, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]]
let year = new Date().getFullYear()
let month = new Date().getMonth() + 1

this.year4 = [year + '', month + '']
this.changeTime = [year + '', month + '']

this.yearMonth = year + '年' + month + '月'

this.getStartEnd()
},
methods: {
getOpenTime () {


this.year4 = this.changeTime
this.pickerShow = true
},
sendTime () {

this.changeTime = [this.year4[0], this.year4[1]]
this.yearMonth = this.changeTime[0] + '年' + this.changeTime[1] + '月'
this.getStartEnd()
this.pickerShow = false
setTimeout(() => {
let page = {num: 1, size: 10}
this.upCallback(page)
}, 100)
},
change (value) {
console.log('new Value', value)
},
getStartEnd () {
let year = new Date().getFullYear() + ''
let month = new Date().getMonth() + 1 + ''
let day = new Date().getDate() + ''
let endMonth = this.changeTime[1].length === 1 ? '0' + this.changeTime[1] : this.changeTime[1]
let endDay = this.getDay(this.changeTime[0], this.changeTime[1])
if (this.changeTime[0] === year && this.changeTime[1] === month) {
let today = day.length === 1 ? '0' + day : day
this.start = this.changeTime[0] + '-' + endMonth + '-01'
this.end = this.common.GetDateStr(1, this.changeTime[0] + '-' + endMonth + '-' + today)
} else {
this.start = this.changeTime[0] + '-' + endMonth + '-01'
this.end = this.common.GetDateStr(1, this.changeTime[0] + '-' + endMonth + '-' + endDay)
}
},
getDay (year, month) {
let day31 = ['1', '3', '5', '7', '8', '10', '12']
let day30 = ['4', '6', '9', '11']
let day = ''
if (day31.indexOf(month) > -1) {
day = '31'
} else if (day30.indexOf(month) > -1) {
day = '30'
} else {

if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
day = '29'
} else {
day = '28'
}
}
return day
},

mescrollInit (mescroll) {
this.mescroll = mescroll 
},
upCallback (page, mescroll) {


let vm = this
this.page = page.num
let data = {
cnt: parseInt(this.cnt),
page: parseInt(page.num),
dids: [this.deviceData.id],
start: this.start,
end: this.end
}
querydevicelog(data).then(res => {
if (res.code === 200) {
if (res.data) {
let data = res.data
for (let i = 0; i < data.length; i++) {
if (data[i].config !== '' && typeof data[i].config === 'string') {
let config = JSON.parse(data[i].config)
while (typeof config === 'string') {
config = JSON.parse(config)
}
data[i].config = config
}
}
if (page.num === 1) {
this.alarmData = data
} else {
this.alarmData = this.alarmData.concat(data)
}
}
} else {
}
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(this.alarmData.length)
}, 100)
})
}).catch(() => {
this.$nextTick(() => {
setTimeout(() => {
vm.mescroll.endSuccess(0)
}, 100)
})
})
},
getUrl (item) {
let url = ''
for (let i = 0; i < this.iconType.length; i++) {
if (this.iconType[i].type === item.alarm_type) {
url = this.iconType[i].url
}
}
return url
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/historyList.vue